import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Globals } from '../base/util/globals';


@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

    @Input() exibeButtonClose = true;
    @Input() newModal = false;
    @Input() visible;
    @Output() visibleChange = new EventEmitter<boolean>();

    constructor(public globals: Globals) { }

    ngOnInit() {}

    hide() {
        this.visible = false;
        this.visibleChange.emit(false);
    }

    visibleFunc() {
        this.globals.modalVisivel = this.visible;
        return this.visible;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/modal.component.ts